/**
 * Show/hide locations by selected country.
 */
 function locations_filter_country(){

    if(!!document.querySelector('.locations-locations__container #list-view #country')){
        
        const selectCountry = document.querySelector('#country');

        selectCountry.addEventListener('change', e => {
            e.preventDefault();

            if(e.target.value != ""){
          
                const countries = document.querySelectorAll(".country-locations");
      
                countries.forEach((country) => {
                    country.style.display = 'none';
                });
    
                const country = document.querySelector('[data-country-id="'+e.target.value+'"]');
    
                country.style.display = 'flex';

            }else{
                
                const countries = document.querySelectorAll(".country-locations");
      
                countries.forEach((country) => {
                    country.style.display = 'flex';
                });

            }
        });
    }

}

locations_filter_country();

export default locations_filter_country;